import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AuthService } from '../../../core/auth/auth.service';

@Component({
  selector: 'hb-app-loginerror',
  templateUrl: './loginerror.component.html',
})
export class LoginErrorComponent implements OnInit, OnDestroy {
  private unsubscribe: Subject<boolean> = new Subject();

  UserNotAuthenticated: boolean;

  constructor(public router: Router, public authService: AuthService) { }

  ngOnInit() {
    this.authService.hideSpinner();
  }

  ngOnDestroy() {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
  }
}
